const getters = {
  user: state => state.user.info,
  order: state => state.order,
};

export default getters;
